export const T = {
  en_GB: {
    removeAllocation: "Remove allocation",
    addPatch: "Add patch",
    changePatch: "Change patch",
    removePatch: "Remove patch",
    currencyMismatch: (patch: string, instrument: string) =>
      `Patch is in ${patch}, instrument is in ${instrument}`,
    hedged: "Hedged",
    converted: (from: string, to: string) => `${from} → ${to} (converted)`,
    hedgedRaw: (from: string) => `${from} (hedged, raw series)`,
    sameCurrency: "Same currency as the basket, no conversion",
    patchNotNeeded: (years: string) =>
      `The instrument already has ${years} years of history of its own, so it does not need a patch.`,
  },
  nb_NO: {
    removeAllocation: "Fjern allokering",
    addPatch: "Legg til patch",
    changePatch: "Endre patch",
    removePatch: "Fjern patch",
    currencyMismatch: (patch: string, instrument: string) =>
      `Patchen er i ${patch}, instrumentet er i ${instrument}`,
    hedged: "Hedget",
    converted: (from: string, to: string) => `${from} → ${to} (konvertert)`,
    hedgedRaw: (from: string) => `${from} (hedget, rå serie)`,
    sameCurrency: "Samme valuta som kurven, ingen konvertering",
    patchNotNeeded: (years: string) =>
      `Instrumentet har allerede ${years} års egen historikk og trenger derfor ingen patch.`,
  },
} as const;
